// extracted by mini-css-extract-plugin
module.exports = {"labels":"styles_labels__2UNa2","label":"styles_label__H9DaR"};